import { Music2, Sparkles, Star } from "lucide-react";

export const Decor = () => (
  <div aria-hidden className="pointer-events-none absolute inset-0 overflow-hidden">
    <div className="starburst float-slow absolute left-[6%] top-[18%] h-16 w-16 bg-amber-400/80" />
    <div className="starburst float-slow absolute right-[8%] top-[60%] h-10 w-10 bg-pink-500/80" style={{ animationDelay: "1.5s" }} />
    <Music2 className="float-slow absolute right-[12%] top-[14%] h-10 w-10 text-cyan-400/70" style={{ animationDelay: "0.8s" }} />
    <Sparkles className="float-slow absolute left-[10%] bottom-[14%] h-9 w-9 text-amber-300/70" style={{ animationDelay: "2.2s" }} />
    <Star className="float-slow absolute left-[48%] top-[6%] h-6 w-6 text-pink-400/70" style={{ animationDelay: "3s" }} />
  </div>
);
